{
  "0": { "X": "1.6960115254403", "Y": "0.758016569978441", "FID": "0" },
  "1": { "X": "0.525066061067823", "Y": "0.084993617299706", "FID": "1" },
  "2": { "X": "-1.55628497469438", "Y": "-1.14069920827872", "FID": "2" },
  "3": { "X": "-1.80261874255555", "Y": "0.661535753822319", "FID": "3" },
  "4": { "X": "-0.713555255156345", "Y": "-0.466880841359134", "FID": "4" },
  "5": { "X": "-0.315129886839841", "Y": "1.31507017740045", "FID": "6" },
  "7": { "X": "2.0530447887205", "Y": "-1.25814828122689", "FID": "7" },
  "6": { "X": "0.803327824645502", "Y": "-1.26433049727074", "FID": "8" }
}
